<template lang="pug">
    .settings-page.settings-profile
        settings-page-head
        .settings-page__body
            .profile-upload-images-wrapper
                drag-and-drop-image-upload(ref="coverImage" :intialImage="coverImage" recommendedSizeText="1400 x 280 (5 : 1)")
                .profile-image-upload
                    input.profile-image-input(type="file" accept="image/*" @change="addFileProfile" ref="profileImageInput")
                    label(:class="{ 'profile-image-border': !profileImageAvailable }" :style="profileImageThumb" @click="changeUserPhoto")
                        svg-icon(iconId="plus" v-if="!profileImageAvailable")
                    settings-image-actions.user-profile-image(v-if="profileImageAvailable" @deletePhoto="deleteUserPhoto" @changePhoto="changeUserPhoto")

            .profile-details
                .settings-section-head Profile Details
                .row
                    .col-sm-6
                        .re-inp-box
                            re-input(label="First Name" v-model.trim="$v.fields.first_name.$model" :validations="validations.first_name" :v="$v.fields.first_name" @input="$v.fields.first_name.$reset")
                    .col-sm-6
                        .re-inp-box
                            re-input(label="Last Name" v-model.trim="$v.fields.last_name.$model" :validations="validations.last_name" :v="$v.fields.last_name" @input="$v.fields.last_name.$reset")
                    .col-12
                        .re-inp-box
                            re-textarea(label="Description" v-model.trim="fields.about")

            re-toast-alert(v-if="errorMessageProfile" type="danger") {{ errorMessageProfile }}

            .settings-save-button.text-right
                re-button.btn-primary.btn-lg(@click="submit" :loading="formSubmitting") Save

</template>

<script>
import ReProfileEdit from 'utils/vue/components/complex/profile/re-profile-edit/script.js'
import UploadedFileUtils from '../../lib/uploaded-file-utils'

export default {
    name: 'lairdnd-profile-edit',

    mixins: [
        ReProfileEdit
    ],

    data() {
        return {
            fields: {
                about: '',
            },
            profileImage: null,
            profileImageRemoved: false,
        }
    },

    computed: {
        coverImage() {
            return this.user.cover_image ? `${this.baseUri}${this.user.cover_image}` : null
        },
        profileImageThumb() {
            let url = null

            if (this.profileImage) {
                url = URL.createObjectURL(this.profileImage)
            } else {
                if (!this.profileImageRemoved && this.user.profile_image) {
                    url = `${this.baseUri}${this.user.profile_image}`
                }
            }

            return url ?
                { 'background-image': "url(" + url + ")" } :
                { "background-color": "#F3F3F3" }
        },
        profileImageAvailable() {
            return this.profileImage || (!this.profileImageRemoved && this.user.profile_image)
        },
    },

    created() {
        this.fields.about = this.user.about
    },

    methods: {
        async submit() {
            const payload = {
                first_name: this.fields.first_name,
                last_name: this.fields.last_name,
                about: this.fields.about,
            }

            if (this.profileImage || this.profileImageRemoved) {
                payload.profile_image = await UploadedFileUtils.getFileBase64(this.profileImage)
            }
            if (this.$refs.coverImage.bgFile || this.$refs.coverImage.initialImageRemoved) {
                payload.cover_image = await UploadedFileUtils.getFileBase64(this.$refs.coverImage.bgFile)
            }

            this.isSuccessPersonal = null
            this.$v.$touch()
            if (await this.changeProfile(payload)) {
                this.isSuccessPersonal = true

                window.scrollTo({ top: 0, behavior: 'smooth' })
            }
        },

        addFileProfile(e) {
            const droppedFile = e.target.files[0]
            if (droppedFile) {
                this.profileImage = droppedFile
            }
            e.target.value = ''
            
        },
        deleteUserPhoto() {
            if (this.profileImage) {
                this.profileImage = null
            } else {
                this.profileImageRemoved = true
            }
        },
        changeUserPhoto() {
            this.$refs.profileImageInput.click()
        },
    }
}
</script>
